<template>
  <div
    v-if="showSuccessModal"
    class="fixed inset-0 flex items-center justify-center bg-black/70 z-[9999] px-4"
  >
    <div
      class="relative w-full max-w-xl bg-[#10172A]/80 backdrop-blur-md border border-[#00F0FF]/30 rounded-2xl shadow-[0_0_25px_#00f0ff60] text-white overflow-hidden"
    >
      <!-- Close Button -->
      <button
        @click="$emit('closeSuccessModal')"
        class="absolute top-3 right-5 text-white text-3xl font-bold hover:text-[#00F0FF] transition"
      >
        &times;
      </button>

      <!-- Modal Header -->
      <div
        class="bg-gradient-to-r from-[#00F0FF] to-[#1ED6FF] text-black p-4 font-bold uppercase tracking-wide text-lg rounded-t-2xl"
      >
        {{ $t('Modal.RaffleSuccess.SuccessfulEntry') }}
      </div>

      <!-- Body -->
      <div class="px-6 pt-6 pb-8 text-center">
        <h2 class="text-[#00F0FF] text-xl sm:text-2xl font-bold flex items-center justify-center gap-2">
          {{ $t('Modal.RaffleSuccess.Congrats') }}
        </h2>

        <p class="text-white/80 text-sm mt-4">
          {{ $t('Modal.RaffleSuccess.YouAdded') }}
          <span class="text-[#00F0FF] font-bold">{{ ticket }}</span>
          {{ ticket === 1 ? $t('Modal.RaffleSuccess.Entry') : $t('Modal.RaffleSuccess.Entries') }}.<br />
          {{ $t('Modal.RaffleSuccess.TotalEntries') }}
          <span class="text-[#00F0FF] font-bold">{{ totalEntries }}</span>
        </p>

        <!-- Ticket List -->
        <div class="w-full text-left mt-6">
          <p class="text-white font-bold text-sm">{{ $t('Modal.RaffleSuccess.YourTicketIDs') }}</p>

          <div
            v-if="localTicketIds?.length"
            class="mt-2 w-full max-h-40 overflow-y-auto custom-scrollbar space-y-2"
          >
            <ul class="text-sm text-white">
              <li
              v-for="(ticket, index) in localTicketIds"

               :key="ticket.ticketId"
                class="bg-[#0D121C] border border-[#00F0FF30] rounded-lg px-4 py-3"
              >
                <div class="flex justify-between items-center text-white/90">
                  <span class="text-[#00F0FF] font-bold">{{ index + 1 }}.</span>
                  <span class="ticket-id text-xs truncate">{{ ticket.ticketId }}</span>
                  <span class="text-xs text-white/60 ml-4">
                    {{ getElapsedTime(ticket.createdAt) }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    raffleName: String,
    ticket: Number,
    totalEntries: Number,
    ticketIds: {
      type: Array,
      default: () => [],
    },
    showSuccessModal: Boolean,
  },
  data() {
    return {
      intervals: [],
      localTicketIds: [],
    };
  },
  methods: {
    getElapsedTime(createdAt) {
      const createdDate = new Date(createdAt);
      const now = new Date();
      const diff = now - createdDate;

      const seconds = Math.floor(diff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) return `${days} ` + this.$t('Modal.RaffleSuccess.DaysAgo');
      if (hours > 0) return `${hours} ` + this.$t('Modal.RaffleSuccess.HoursAgo');
      if (minutes > 0) return `${minutes} ` + this.$t('Modal.RaffleSuccess.MinutesAgo');
      return `${seconds} ` + this.$t('Modal.RaffleSuccess.SecondsAgo');
    },
    updateElapsedTime() {
      this.localTicketIds = this.localTicketIds.map((ticket) => ({
        ...ticket,
        elapsedTime: this.getElapsedTime(ticket.createdAt),
      }));
    },
    startElapsedTimeUpdate() {
      this.updateElapsedTime();
      const interval = setInterval(this.updateElapsedTime, 1000);
      this.intervals.push(interval);
    },
    stopElapsedTimeUpdate() {
      this.intervals.forEach(clearInterval);
      this.intervals = [];
    },
  },
  watch: {
    showSuccessModal(val) {
      if (val) {
        this.localTicketIds = this.ticketIds.map((ticket) => ({
          ...ticket,
          elapsedTime: this.getElapsedTime(ticket.createdAt),
        }));
        this.startElapsedTimeUpdate();
      } else {
        this.stopElapsedTimeUpdate();
      }
    },
  },
  unmounted() {
    this.stopElapsedTimeUpdate();
  },
};
</script>


<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #00f0ff;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #1ed6ff;
}
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #00f0ff transparent;
}

.ticket-id {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}
@media (max-width: 1024px) {
  .ticket-id {
    max-width: 80px;
  }
}
@media (min-width: 1025px) {
  .ticket-id {
    max-width: 200px;
  }
}
</style>
